import React from "react";
import { useNavigate } from "react-router-dom";
import DemoButton from "../shared/DemoButton";
import HeroWorkQueue from "../shared/HeroWorkQueue";
import "./Hero.css";

export default function Hero() {
  const navigate = useNavigate();

  return (
    <>
      {/* Mobile UI — unchanged */}
      <section className="hero-container hero-mobile">
        <div className="hero-badge">
          <img src="/icons/brain.svg" alt="brain Icon" /> Enterprise Intelligence Platform
        </div>

        <h1 className="hero-heading mb-6">
          The Trusted Intelligence Layer for the Enterprise
        </h1>

        <p className="hero-subtext">
          Highwatch connects every system, understands your business context, and delivers verified, compliant answers, instantly.
        </p>

        <div className="hero-buttons">
          <button
            className="primary-button"
            type="button"
            onClick={() => navigate("/Contact")}
          >
            Learn How It Works
            <img src="/icons/arrow-narrow-right.svg" alt="arrow-narrow-right Icon" />
          </button>
        </div>

        <section className="brand-section">
          <p className="brand-subtext">
            Powering secure, context-aware decisions across finance, healthcare, and insurance enterprises.
          </p>
        </section>
      </section>

      {/* Desktop web UI — Figma */}
      <section className="hw-hero-desktop">
        <div className="hw-hero-desktop__glow" />
        <div className="hw-hero-desktop__grid" />

        <div className="hw-hero-desktop__content">
          <div className="hw-hero-desktop__badge">
            <span className="hw-hero-desktop__badge-dot" />
            ENTERPRISE INTELLIGENCE LAYER
          </div>

          <h1 className="hw-hero-desktop__heading">
            One intelligence layer.
            <br />
            <span>Built for every regulated industry.</span>
          </h1>

          <p className="hw-hero-desktop__subtext">
            Highwatch unifies knowledge, automates operations, and drives decisions —
            across Insurance, Finance, and Healthcare — on a single explainable AI layer
            with full audit trails built in.
          </p>

          <div className="hw-hero-desktop__actions">
            <DemoButton as="button" onClick={() => navigate("/Contact")} />
            <button
              type="button"
              className="hw-btn hw-btn--ghost"
              onClick={() => {
                const el = document.getElementById("why-highwatch");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Learn How It Works →
            </button>
          </div>

          <p className="hw-hero-desktop__fineprint">
            No credit card required · Built for SOC 2 / GDPR-ready environments
          </p>
        </div>

        <div className="hw-hero-desktop__visual hw-hero-desktop__visual--enter">
          <HeroWorkQueue />
        </div>
      </section>
    </>
  );
}
